import MCHCHAN from '@/api/module/mchchan.js';
const CHANNEL = {
  namespaced: true,
  state: {
    // 已开通列表
    mchchanList: [],
    // 开通应用详情
    mchDetail: {},
  },
  mutations: {
    // 设置已开通渠道列表
    setmchchanList(state, data) {
      state.mchchanList = data||[];
    },
    // 设置已开通渠道主页
    setmchchanDetail(state, data) {
      state.mchDetail = data;
    },
  },
  actions: {
    // 获取已开通渠道
    async getMchchanList({ commit }, params) {
      try {
        const result = await MCHCHAN.getMchchan(params);
        commit('setmchchanList', result);
        return Promise.resolve(result);
      } catch (err) {
        return Promise.reject(err);
      }
    },
    // 设置微信JSAPI 支付参数
    // eslint-disable-next-line
    async addWechatJsapi({ commit }, params) {
      try {
        const result = await MCHCHAN.addMchchan(params);
        return Promise.resolve(result);
      } catch (err) {
        return Promise.reject(err);
      }
    },
    // 设置汇付宝支付参数
    // eslint-disable-next-line
    async addHeepay({ commit },params) {
      try {
        const result = await MCHCHAN.addHeepay(params);
        return Promise.resolve(result);
      } catch (err) {
        return Promise.reject(err);
      }
    },
    // 获取已开通渠道详情
    async getDetailById({ commit }, params) {
      try {
        const result = await MCHCHAN.getDetail(params);
        commit('setmchchanDetail', result);
        return Promise.resolve(result);
      } catch (err) {
        return Promise.reject(err);
      }
    },
    // 修改渠道参数
    // eslint-disable-next-line
    async changeMchchan( { commit }, params) {
      try {
        await MCHCHAN.updateMchchan(params);
        return Promise.resolve('修改成功');
      } catch (err) {
        return Promise.reject(err);
      }
    },
    // 修改汇付宝渠道参数
    // eslint-disable-next-line
    async editHeepay( { commit }, params) {
      try {
        await MCHCHAN.editHeepay(params);
        return Promise.resolve('修改成功');
      } catch (err) {
        return Promise.reject(err);
      }
    },
  },
  getters: {
    mchchanList: state => state.mchchanList,
    mchDetail: state => state.mchDetail,
    mchchanDetail: state => state.mchchanDetail,
  },
};

export default CHANNEL;
